export default __webpack_public_path__ + "static/capital_budgeting-6060290229da4c9304de398fd45d7328.png";